import { MESSAGE_STATUS_FILTER } from "./messageStatus";

export const emptyDate = () => ({ fa: "", en: "" });

export const emptyAiSummaryFilters = () => ({
    item_type: null,
    item: null,
    datetime_from: emptyDate(),
    datetime_to: emptyDate(),
    user: null,
    feedback_status: MESSAGE_STATUS_FILTER.ALL,
    include_comments: true,
});

export function toAiSummaryParams(filters, company) {
    const params = {};
    if (filters?.item_type) params.item_type = filters.item_type;
    if (filters?.item) params.item = filters.item;
    if (filters?.datetime_from?.en) {
        params.datetime_from = filters.datetime_from.en;
    }
    if (filters?.datetime_to?.en) {
        params.datetime_to = filters.datetime_to.en;
    }
    if (filters?.user) params.user = filters.user;
    if (filters?.feedback_status) {
        params.feedback_status = filters.feedback_status;
    }
    params.include_comments = filters?.include_comments !== false;
    if (company) params.company = company;
    return params;
}

export function flattenItemTypeOptions(nodes, prefix = "") {
    const options = [];
    (Array.isArray(nodes) ? nodes : []).forEach((node) => {
        const label = prefix ? `${prefix} / ${node.name}` : node.name;
        options.push({ value: node.id, label });
        if (node.children?.length) {
            options.push(...flattenItemTypeOptions(node.children, label));
        }
    });
    return options;
}

export function describeAiSummaryFilters(filters, t) {
    const chips = [];
    if (filters?.item_type) {
        chips.push({
            id: "item_type",
            label: `${t("Organizational.Messages.AiSummary.ItemType")}: ${
                filters.itemTypeLabel || filters.item_type
            }`,
        });
    }
    if (filters?.item) {
        chips.push({
            id: "item",
            label: `${t("Organizational.Messages.AiSummary.Item")}: ${
                filters.itemLabel || filters.item
            }`,
        });
    }
    if (filters?.datetime_from?.fa || filters?.datetime_to?.fa) {
        const from = filters.datetime_from?.fa || "…";
        const to = filters.datetime_to?.fa || "…";
        chips.push({
            id: "dates",
            label: `${from} — ${to}`,
        });
    }
    if (filters?.user) {
        chips.push({
            id: "user",
            label: `${t("Organizational.Messages.AiSummary.User")}: ${
                filters.userLabel || filters.user
            }`,
        });
    }
    if (filters?.feedback_status) {
        const statusKey = {
            [MESSAGE_STATUS_FILTER.NEW]:
                "Organizational.Messages.Status.New",
            [MESSAGE_STATUS_FILTER.IN_PROGRESS]:
                "Organizational.Messages.Status.InProgress",
            [MESSAGE_STATUS_FILTER.CLOSED]:
                "Organizational.Messages.Status.Closed",
        }[filters.feedback_status];
        if (statusKey) {
            chips.push({
                id: "status",
                label: `${t("Organizational.Messages.MessagesStatus")}: ${t(statusKey)}`,
            });
        }
    }
    if (filters?.include_comments === false) {
        chips.push({
            id: "comments",
            label: t("Organizational.Messages.AiSummary.CommentsOff"),
        });
    }
    return chips;
}

export function filtersFromSnapshot(snapshot) {
    const base = emptyAiSummaryFilters();
    if (!snapshot || typeof snapshot !== "object") {
        return base;
    }
    const dateFrom = snapshot.datetime_from;
    const dateTo = snapshot.datetime_to;
    return {
        ...base,
        item_type: snapshot.item_type || null,
        item: snapshot.item || null,
        itemTypeLabel: snapshot.itemTypeLabel || "",
        itemLabel: snapshot.itemLabel || "",
        user: snapshot.user || null,
        userLabel: snapshot.userLabel || "",
        feedback_status:
            snapshot.feedback_status || MESSAGE_STATUS_FILTER.ALL,
        include_comments: snapshot.include_comments !== false,
        datetime_from:
            dateFrom && typeof dateFrom === "object"
                ? { fa: dateFrom.fa || "", en: dateFrom.en || "" }
                : base.datetime_from,
        datetime_to:
            dateTo && typeof dateTo === "object"
                ? { fa: dateTo.fa || "", en: dateTo.en || "" }
                : base.datetime_to,
    };
}

export function formatSummaryDateTime(value) {
    if (!value) return "—";
    const match = String(value).match(
        /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/
    );
    if (match) return `${match[1]} ${match[2]}`;
    return String(value);
}
